// src/constants/roleAccess.js

import { PERMISSIONS as P } from "./permissions";

export const ROLE_ACCESS = {
  admin: Object.values(P), // full access

  assistant: [
    P.DASHBOARD_VENUE,
    P.DASHBOARD_NIGHT,
    P.DASHBOARD_SELECTOR,
    P.VENUE_VIEW,
    P.VENUE_CREATE,
    P.VENUE_EDIT,
    P.VENUE_DELETE,
    P.VENUE_DOWNLOAD,
    P.ANALYTICS_VIEW,
    P.SEARCH_VIEW,
    P.DOWNLOAD_VIEW,
    P.NOTIFICATIONS_VENUE,
    P.CALENDAR_VIEW,
    P.UPCOMING_VIEW,
    P.SOCIETY_BUDGET_VIEW,
    P.SOCIETY_BUDGET_MANAGE,
    P.FILTER_VIEW
  ],

  dd_assistant: [
    P.DASHBOARD_VENUE,
    P.VENUE_VIEW,
    P.VENUE_CREATE,
    P.VENUE_EDIT,
    P.VENUE_DELETE,
    P.VENUE_DOWNLOAD,
    P.ANALYTICS_VIEW,
    P.SEARCH_VIEW,
    P.DOWNLOAD_VIEW,
    P.NOTIFICATIONS_VENUE,
    P.CALENDAR_VIEW,
    P.UPCOMING_VIEW,
    P.FILTER_VIEW
  ],

  manager: [
    P.DASHBOARD_GUEST,
    P.SIDEBAR_ALL_HOSTELS,
    P.SIDEBAR_HOSTELS,
    P.ANALYTICS_VIEW,
    P.ENQUIRY_VIEW,
    P.ENQUIRY_DOWNLOAD,
    P.SEARCH_VIEW,
    P.DOWNLOAD_VIEW,
    P.NOTIFICATIONS_ENQUIRY,
    P.CALENDAR_VIEW,
    P.UPCOMING_VIEW,
    P.FILTER_VIEW,
    P.SETTINGS_OPEN,
    P.SETTINGS_CACHE,
    P.SETTINGS_APPROVED
  ],

  co_warden: [
    P.DASHBOARD_GUEST,
    P.SIDEBAR_ALL_HOSTELS,
    P.SIDEBAR_HOSTELS,
    P.ANALYTICS_VIEW,
    P.ENQUIRY_VIEW,
    P.ENQUIRY_DOWNLOAD,
    P.SEARCH_VIEW,
    P.DOWNLOAD_VIEW,
    P.NOTIFICATIONS_ENQUIRY,
    P.CALENDAR_VIEW,
    P.UPCOMING_VIEW,
    P.FILTER_VIEW,
    P.SETTINGS_OPEN,
    P.SETTINGS_CACHE,
    P.SETTINGS_APPROVED
  ],

  warden: [
    P.DASHBOARD_GUEST,
    P.SIDEBAR_HOSTELS,
    P.SEARCH_VIEW,
    P.DOWNLOAD_VIEW,
    P.CALENDAR_VIEW,
    P.UPCOMING_VIEW,
    P.FILTER_VIEW
  ],

  caretaker: [
    P.DASHBOARD_GUEST,
    P.DASHBOARD_NIGHT,
    P.SIDEBAR_HOSTELS,
    P.NIGHT_SCAN,
    P.DASHBOARD_SELECTOR,
    P.SEARCH_VIEW,
    P.DOWNLOAD_VIEW,
    P.CALENDAR_VIEW,
    P.UPCOMING_VIEW,
    P.FILTER_VIEW
  ],

  adosa: [
    P.DASHBOARD_VENUE,
    P.DASHBOARD_NIGHT,
    P.DASHBOARD_SELECTOR,
    P.NIGHT_ADMIN,
    P.VENUE_VIEW,
    P.VENUE_CREATE,
    P.VENUE_EDIT,
    P.VENUE_DELETE,
    P.VENUE_DOWNLOAD,
    P.SEARCH_VIEW,
    P.ANALYTICS_VIEW,
    P.DOWNLOAD_VIEW,
    P.NOTIFICATIONS_VENUE,
    P.CALENDAR_VIEW,
    P.UPCOMING_VIEW,
    P.SOCIETY_BUDGET_VIEW,
    P.SOCIETY_BUDGET_MANAGE,
    P.FILTER_VIEW
  ],
};
